import apiUrl from '../../../constants';
import awsBucketName from '../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
import Multiselect from 'vue-multiselect'
import 'vue-multiselect/dist/vue-multiselect.min.css';
import { createRECManifest } from '../../../services/createRECManifest';
import { actionStatuses } from '../../../services/actionStatus';
import UserIPTracking from '../../../interface/userTracker';
import { sendIPTrackingData } from '../../../services/userIPTrack';
import {getImgVidProofs} from '../../../services/externalDispute';

export default {
  name: 'editproductdamage',
  components: {
    Paginate,
    VueElementLoading,
    Multiselect,
  },
  data() {
    return {
      attachment: null,
      displaytable: false,
      imagesarr: [],
      attachment: null,
      displaytable: false,
      description: '',
      image: '',
      username: '',
      statuss: '',
      statusCode: '',
      // try
      path: `${awsBucketName}/1234/wallpaperflare.com_wallpaper-1.jpg`,
      //   fname1: 'download.jpeg',
      fname1: 'wallpaperflare.com_wallpaper-1.jpg',
      imgdata: '',
      showModal: false,
      awbnumber: '',
      damage_type: '',
      verifiedas: '',
      update_dispose: [],
      takeactionlist: [],
      takeActionname: '',
      takeactionId: '',
      takeActionloader: false,
      show: false,
      istakeAction: false,
      FileSelected: null,
      shippingIdArray: [],
      actionStatusCode:'',   
      STDassets : [],   
      showClientMediaModal : false,
      damageCategoryList: [{
        value: "Liquid",
        label: 'Liquid'
    }, {
        value: "Fragile ",
        label: 'Fragile '
    }, {
        value: "Not Liquid/Fragile ",
        label: 'Not Liquid/Fragile '
    }],
    damageCategoryData: '',
    isActive:false
    };
  },
  mounted() {
    var queryParam = [];
    let shipmentQueryParams = [];

    var userToken = window.localStorage.getItem('accessuserToken');
    this.myStr = userToken.replace(/"/g, '');
    this.username = window.localStorage.getItem('username');
    this.actionStatusCode = this.$route.query.actionStatusCode
    queryParam.push(this.$route.query.bulk ? this.$route.query.bulk : this.$route.query);
    this.statusCode = queryParam[0][0] ? queryParam[0][0].status : queryParam[0].status;

    shipmentQueryParams = (queryParam[0].length) ? queryParam[0] : queryParam;

    shipmentQueryParams.map(param => this.shippingIdArray.push(param.shippingid));

    this.awbnumber = this.shippingIdArray.toString();
    this.takeAction()
    setTimeout(()=>{
      document.documentElement.scrollTop = 0;
      },500);
  },
  methods: {

    async takeAction() {
      this.takeactionlist = await actionStatuses(this.statusCode, 4, this.myStr);
     if(this.actionStatusCode !== '12') this.takeactionlist
     else this.takeactionlist = this.takeactionlist.filter(person => person.id !== 12);      
      if (this.takeactionlist.length == 0) {
        this.istakeaction = true;
      }
    },

    onFileChange(e) {
      this.attachment = e.target.files[0];
      this.FileSelected = this.attachment;
      this.FileSelected = null;

    },

    resetForm() {
      if (this.imagesarr.length != []) {
        this.$alertify.error("Please Delete image");
      } this.$validator.reset(); this.errors.clear();
    },


    Backinvestigation() {
      if (this.imagesarr.length != []) {
        this.$alertify.error("Please Delete image")
      }
      else if(this.statusCode == 1){
        this.$router.push({ path: '/PackagingDamageBySecurityTeam' });
      }
      else {
        this.$router.push({ path: '/ProductDamageByFinance' });
      }

    },

    selectData(actionId, actionName) {   
        if ([26, 7, 4].includes(actionId) && this.actionStatusCode !== '12'){
          this.isActive=true
        }
      else this.isActive=false
          this.takeactionId = actionId;
      this.actionName = actionName;
    },

    updatedata() {
      if (!this.takeactionId) {
        this.$alertify.error("Please Select Damage Type")
      } else if (!this.description) {
        this.$alertify.error("Please Fill Description.")
      }
      else if (this.statusCode === 1 && this.actionStatusCode !== '12' && !this.damageCategoryData &&  this.isActive==true) {
        
        this.$alertify.error("Please mark DamageCatergery .")
      }
      else {

        this.update_dispose_ShipmentVerifiedAs = ({
          ShippingID: this.shippingIdArray,
          ShipmentVerifiedAs: this.username,
          ActionStatusId: this.takeactionId.toString(),
          Comments: this.description,
          LastModifiedBy: this.username
        });
        this.update_disposes = ({
          ShippingID: this.shippingIdArray,
          // ShipmentVerifiedAs: this.username,
          ActionStatusId: this.takeactionId.toString(),
          Comments: this.description,
          LastModifiedBy: this.username
        });
        if (this.statusCode === 1 && this.actionStatusCode !== '12' && this.isActive==true) {
          this.update_dispose_ShipmentVerifiedAs.damageCategory = this.damageCategoryData.label;
          this.update_disposes.damageCategory = this.damageCategoryData.label;
        }
        //   this.DamageActionbySecurity();
        if (this.takeactionId == 4 || this.takeactionId == 2) {
          this.UpadteInvestigateShipmentRecoveryBySecurity(this.update_disposes)
        } else {
          this.UpdateDisposeAndForcefullyLostFinance(this.update_dispose_ShipmentVerifiedAs);
        }
      }
    },


    DamageActionbySecurity() {
      if (this.statuss == "") {
        this.$alertify.error("Status  Not Exist")

      }
      let currentdate = moment(new Date()).format("DD-MM-YYYY HH:mm:ss");
      this.input = ({
        ShipmentData: this.queryParam,
        StatusMarkedFrom: "Web",
        Comments: this.description,
        LastModifiedBy: this.username,
        LastModifiedDate: currentdate,
        RequestFrom: "Security",
        Description: "",
        DebitTo: ""
      });
      axios({
        method: 'post',
        url: apiUrl.api_url + 'DamageActionbySecurity',
        data: this.input,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        if (result.data.code == 200) {
          this.$alertify.success(result.data.message)
          this.$router.push({ path: '/ProductDamageByFinance' });
        }
        else {
          this.$alertify.error(result.data.message)
        }
      })
    },


    UpdateDisposeAndForcefullyLostFinance(payload) {
      if (this.takeactionId == 7 || this.takeactionId == 25 || this.takeactionId == 24) {
        let useriptracking = new UserIPTracking();
        let userTrackingData = useriptracking.setMeta(this.actionName, this.awbnumber)
          .setRouteUrl('/ProductDamageByFinance')
          .createObject();
        sendIPTrackingData(userTrackingData);
      }
      axios({
        method: 'post',
        url: apiUrl.api_url + 'UpdateDisposeAndForcefullyLostFinance',
        data: payload,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        if (result.data.data2[0].ReturnCode == 100) {
          setTimeout(async () => {
            if (this.damage_type == 24) {
              payload.ShippingID.map(async shippingId => {
                await createRECManifest(shippingId, this.myStr);
              });
            }
            this.$alertify.success(result.data.data2[0].ReturnMessage);
            this.$router.push({ path: '/ProductDamageByFinance' });
          }, 500);
        }
        else {
          this.$alertify.error(result.data.data2[0].ReturnMessage)
        }
      })
    },

    UpadteInvestigateShipmentRecoveryBySecurity(payload) {
      payload.InvestigationBatchID = "22";
      payload.RequestFrom = "Finance";

        let useriptracking = new UserIPTracking();
        let userTrackingData = useriptracking.setMeta(this.actionName, this.awbnumber)
          .setRouteUrl('/ProductDamageByFinance')
          .createObject();
        sendIPTrackingData(userTrackingData);
      axios({
        method: 'post',
        url: apiUrl.api_url + 'InvestigateShipmentRecoveryBySecurity',
        data: payload,
        headers: {
          'Authorization': 'Bearer ' + this.myStr
        }
      }).then(result => {
        if (result.data.data2[0].code == 200) {
          this.$alertify.success(result.data.data2[0].message)
          this.$router.push({ path: '/ProductDamageByFinance' });
        }
        else {
          this.$alertify.error(result.data.data2[0].message)
          console.log(result.data.data2[0]);
          this.$router.push({ path: '/ProductDamageByFinance' });

        }
      })
    },
    async openMediaModal(awb) {
      let input = {
        awb : awb,
        status : 1
      }
        const response = await getImgVidProofs(input,this.myStr)
        if (response.data.statusCode !== 100) {
          this.$alertify.error(response.data.msg)
          return;
        }
        const videoExtensions = ['mp4', 'mov', 'avi', 'mkv', 'flv', 'wmv', 'webm'];

        this.STDassets = response.data.data.reduce((acc, item) => {
          let fileExtension = item.key.split('.').pop().toLowerCase();

          if (videoExtensions.includes(fileExtension)) {
            acc.videourl.push({ UnboxingVideoProof1: item.url });
          } else {
            acc.clientImages.push({ attachment: item.url });
          }

          return acc;
        }, { clientImages: [], videourl: [] });
        this.showClientMediaModal = true;
    },
  },
};



// WEBPACK FOOTER //
// ./src/views/components/EditProductDamage/EditProductDamage.component.js